import React from "react";
import { getField, deserializeField } from "../../util/DynamicItemUtils";

export default function PcaobOperationsDocument({ item }: any) {
  return (
    <div>
      <p className="lead-text-lt">Document</p>
      {getField(item, "documentlink") ? (
        <h3>
          <a
            href={deserializeField(item, "documentlink")[0].mediaUrl}
            download
            target="_blank"
          >
            {getField(item, "title")}
          </a>
        </h3>
      ) : (
        <h3>{getField(item, "title")}</h3>
      )}
      <div className="hawk-row">
        {getField(item, "operationsdocumenttypes") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Standard Type</div>
            <div className="lead-text-st">
              {getField(item, "operationsdocumenttypes")}
            </div>
          </div>
        )}
      </div>
      {getField(item, "documentlink") && (
        <a
          href={deserializeField(item, "documentlink")[0].mediaUrl}
          className="hawk-download-pdf"
          download
          target="_blank"
        >
          Download PDF
        </a>
      )}
    </div>
  );
}
